module.exports = __webpack_public_path__ + "static/oop_overall_all-654c1df807fb858460b69d869d9eae0d.png";